import Vue from 'vue'

const saleToken = 'padSale'
const vacToken = 'padVac'

let sale = null
let vac = null
try {
    sale = JSON.parse(Vue.prototype.$storage.get(saleToken)) || {}
    vac = JSON.parse(Vue.prototype.$storage.get(vacToken)) || {}
} catch (e) {
    sale = {}
    vac = {}
}

export default {
    namespaced: true,

    state: {
        sale: sale,
        vacation: vac,
        vacations: []
    },

    getters: {
        sale: state => state.sale,
        vacation: state => state.vacation,
        vacations: state => state.vacations
    },

    mutations: {
        setSale(state, data) {
            state.sale = {
                id: data.sale.id,
                title: data.sale.title
            }
            Vue.prototype.$storage.set(saleToken, JSON.stringify(state.sale))
        },

        setVacation(state, data) {
            state.vacation = {
                id: Number(data.vacation.id),
                text: data.vacation.text
            }
            Vue.prototype.$storage.set(vacToken, JSON.stringify(state.vacation))
        },

        setVacations(state, data) {
            state.vacations = data.vacations
        }
    },

    actions: {
        selectVacation(context, data) {
            const v = context.getters.vacations.find(v => v.id === data.vacation)
            if (v) {
                context.commit('setVacation', { vacation: v })
            }
        }
    }
}
